import React, {Component, Fragment} from 'react';
import logo from './../../img/general/logo.svg';
import { Link, withRouter } from "react-router-dom";
import {connect} from 'react-redux'
import {loadShops, loadCategories, clearCart, clearDeliveryData} from "../../actionCreators";
import Alert from "../Alerts/Alert";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShowAlert: false,
      showAlertText: 'Sicher, dass Sie den Laden wechseln möchten? Warenkorb wird gelöscht.',
      showAlertBtn: 'Fortsetzen',

      isShowAlertTitle: false,
      showAlertTextTitle: 'Sicher, dass Sie zur Hauptseite gehen möchten. Warenkorb- und Lieferdaten werden gelöscht.',
      showAlertBtnActionTitle: 'Fortsetzen'
    };
  }


  componentDidUpdate(prevProps, prevState, snapshot) {
    const {shops, loadCategories, loadedCat, loadingCat, urlHashIndex, history, url_hash} = this.props;
    if(url_hash === 'not-found-shop') {
      return false;
    }
    if(shops && shops.length !== 0) {
      if(url_hash === undefined) {
        let firstShop = shops[0].url_hash;
        let shopAddress = shops[0].address;
        if(!loadedCat && !loadingCat) {
          loadCategories(firstShop, shopAddress);
          history.push(`/shop/${firstShop}`);
        }
      } else if(urlHashIndex === -1) {
        if(!loadedCat && !loadingCat) {
          history.push('/shop/not-found-shop')
        }
      } else {
        let firstShop = urlHashIndex ? shops[urlHashIndex].url_hash : shops[0].url_hash;
        let shopAddress = urlHashIndex ? shops[urlHashIndex].address : shops[0].address;
        if(!loadedCat && !loadingCat) {
          loadCategories(firstShop, shopAddress);
          history.push(`/shop/${firstShop}`);
        }
      }
    }

  }

  componentDidMount() {
    const {loadedShop, loadingShop, loadShops, url_hash} = this.props;
    if(!loadedShop && !loadingShop) {
      loadShops(url_hash);
    }
  }

  renderSelectShop = () => {
    const {shops, loadingShop, url_hash} = this.props;
    if (loadingShop) return <div className="header__top"> <div className="loading">loading...</div> </div>
    if (!shops || !shops.length) return <div className="header__top"> <div className="loading">No shops</div> </div>
    const shopElements = shops.map((shopItem) => {
      const selected = shopItem.url_hash === url_hash;
      return <option key={shopItem.name} value={shopItem.url_hash} selected={selected ? 'default' : ''}>{shopItem.name}</option>
    })
    return (
      <div className="header__top">
        <span>Shop auswählen:</span>
        <select onChange={this.handleChangeShop} ref="hashUrl" >
          {shopElements}
        </select>
      </div>
    )
  };

  handleChangeShop = (e) => {
    const {showAlert, handleClearCart} = this;
    const {cart} = this.props;
    if (this.refs.hashUrl) {
      if(cart.length !== 0) {
        showAlert();
      } else {
        handleClearCart();
      }
    }
  };

  handleClearCart = (e) => {
    const {loadCategories, history, shops} = this.props;
    const {clearCart} = this.props;

    let hashUrl = this.refs.hashUrl.value;
    const shopAddress = shops.filter((item) => item.url_hash === hashUrl)
    loadCategories(hashUrl, shopAddress[0].address);
    history.push(`/shop/${hashUrl}`);

    clearCart();
    clearDeliveryData();
    this.setState({
      isShowAlert: false
    })
  };

  closeAlert = (e) => {
    this.setState({
      isShowAlert: false,
      isShowAlertTitle: false
    })
  };

  showAlert = (e) => {
    this.setState({
      isShowAlert: true
    })
  };

  showAlertTitle = (e) => {
    const {cart} = this.props;
    const {goHomePageTitle} = this;

    if(cart.length !== 0) {
      this.setState({
        isShowAlertTitle: true
      })
    } else {
      goHomePageTitle();
    }
  };

  goHomePageTitle = () => {
    const {history, clearCart, clearDeliveryData} = this.props;
    clearCart();
    clearDeliveryData();
    history.push("./");
  };

  showAlertRenderTitle = () => {
    const {isShowAlertTitle, showAlertTextTitle, showAlertBtnActionTitle} = this.state;
    const {closeAlert, showAlertTitle} = this;
    if(isShowAlertTitle) {
      return <Alert closeAlert={closeAlert} someActionDo={showAlertTitle} alertText={showAlertTextTitle} btnSomeActionDoText={showAlertBtnActionTitle}/>
    }
  };

  renderShowAlert = () => {
    const {isShowAlert, showAlertText, showAlertBtn} = this.state;
    const {handleClearCart, closeAlert} = this;

    if(isShowAlert) {
      return <Alert closeAlert={closeAlert} someActionDo={handleClearCart} alertText={showAlertText} btnSomeActionDoText={showAlertBtn}/>
    }
  };

  render() {
    const {selectShop, categories, isShowAddress} = this.props;
    const {renderSelectShop, renderShowAlert, showAlertRenderTitle} = this;
    return (
      <Fragment>
        <header className="header">
          <div className="container">
            { selectShop ? renderSelectShop() : '' }
          </div>
          <div className="container">
            <div className="header__inner">
              <div className="logo">
                <a href="./../">
                  <img src={logo} alt="" />
                </a>
              </div>
              <div className="header__who-we-are">
                <a href="./../#description">Wer wir sind?</a>
              </div>
              <div className="header__address">
                <address>
                  {isShowAddress ? (
                    ''
                  ) : (
                    <p>
                      {!categories.shopAddress ? 'loading...' : categories.shopAddress}</p>
                  )}
                </address>
              </div>
            </div>
          </div>
        </header>
        { renderShowAlert() }
        { showAlertRenderTitle() }
      </Fragment>
    );
  }
}

export default withRouter(connect((state) => {
  return {
    categories: state.categories,
    cart: state.cart,
    urlHashIndex: state.shops.urlHashIndex,
    shops: state.shops.shopList,
    loadingShop: state.shops.loading,
    loadedShop: state.shops.loaded,
    loadingCat: state.categories.loading,
    loadedCat: state.categories.loaded,
  }
}, {loadShops, loadCategories, clearCart, clearDeliveryData})(Header));


// WEBPACK FOOTER //
// ./src/components/Header/index.js